import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { GoogleLogin } from 'react-google-login'

import ErrorBoundary from '../../components/errorBoundary'
import LoginForm from '../../components/loginForm'
import { ACCESS_TOKEN } from '../../constants'
import {
  FormContainer,
  ContainerLanguage,
  GoogleButton,
  IconButton,
  Footer,
  FooterContentRow,
  ClasswinLogo,
  ContainerLogo,
} from './styles'
import FacebookButton from '../../components/facebookButton'
import VerifyCertificateButton from '../../components/verifyCertificateButton'

import Typography from 'components/typography'
import { Divider } from 'antd'
import WhatClasswinButton from 'components/WhatClasswinButton'
import GoogleImage from '../../images/icons/newGoogleIcon.png'
import { DesktopAndTablet, SmallMobile } from 'utils/displayResponsive'
import LogoClasswin from '../../images/icons/Classwin logo_Classwin Horizontal - Blue 2.svg'

class LogInPage extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    facebookLogin: PropTypes.func.isRequired,
  }

  handleSubmit = async (values) => {
    const { login, history, location, setOpenModal, fetchMe } = this.props
    await login(values)
    await fetchMe()
    if (setOpenModal) {
      setOpenModal(false)
    } else if (location.state && location?.state?.from !== '/logout') {
      history.push(location?.state?.from)
    } else {
      history.push('/browse/courses')
    }
  }

  LoginToFacebook = async (token) => {
    const { facebookLogin } = this.props
    return facebookLogin(token)
  }

  callback = async (data) => {
    const { history } = this.props
    await this.LoginToFacebook({ accessToken: data })
    history.push('/browse')
  }
  handleLogin = async (response) => {
    const { googleLogin } = this.props
    if (response.tokenId) {
      await googleLogin({ token: response.tokenId })
    }
  }
  onChangeLocale = (values) => {
    const { updateLocale } = this.props
    updateLocale(values)
  }
  render() {
    const accessToken = localStorage.getItem(ACCESS_TOKEN)
    const { isModal, location, setTypeModal, hideResetPassword, locale } = this.props

    let from = { pathname: '/browse' }
    if (location.state && location?.state?.from !== '/logout') {
      from = location?.state?.from
    }

    if (accessToken) {
      return <Redirect to={from} />
    }

    return (
      <ErrorBoundary>
        <FormContainer isModal={isModal}>
          <div>
            <ContainerLogo>
              <ClasswinLogo src={LogoClasswin} alt="logo" shape-rendering="crispEdges" />
            </ContainerLogo>
            {!isModal && (
              <ContainerLanguage>
                <Typography
                  color={locale === 'th' ? 'primary1' : 'black38'}
                  onClick={() => {
                    this.onChangeLocale('th')
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  TH
                </Typography>
                <Typography color="black38">|</Typography>
                <Typography
                  color={locale === 'en' ? 'primary1' : 'black38'}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.onChangeLocale('en')
                  }}
                >
                  EN
                </Typography>
              </ContainerLanguage>
            )}
            <LoginForm
              onSubmit={this.handleSubmit}
              setTypeModal={setTypeModal}
              from={from}
              hideResetPassword={hideResetPassword}
            />
            <Divider style={{ padding: '5px 0px 0px 0px', borderColor: '#A9B6C6' }}>
              <Typography color="black38" id="signin.with">
                or Sign in with
              </Typography>
            </Divider>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
              <FacebookButton callback={this.callback} isIcon margin="0 0 0 0" />
              <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                render={(renderProps) => (
                  <IconButton onClick={renderProps.onClick}>
                    <GoogleButton src={GoogleImage} alt="google-btn" />
                  </IconButton>
                )}
                buttonText=""
                onSuccess={this.handleLogin}
                onFailure={this.handleLogin}
                cookiePolicy={'single_host_origin'}
              />
            </div>
          </div>

          <>
            <DesktopAndTablet>
              <Footer>
                <FooterContentRow>
                  <VerifyCertificateButton>Certificate Verification</VerifyCertificateButton>
                  <WhatClasswinButton>What is Classwin</WhatClasswinButton>
                </FooterContentRow>
              </Footer>
            </DesktopAndTablet>
            <SmallMobile>
              <Footer>
                <VerifyCertificateButton margin="0 5px 0 0">
                  Certificate Verification
                </VerifyCertificateButton>
                <WhatClasswinButton margin="0 5px -10px 0">What is Classwin</WhatClasswinButton>
              </Footer>
            </SmallMobile>
          </>
        </FormContainer>
      </ErrorBoundary>
    )
  }
}
const mapState = (state) => ({
  locale: state.Language.locale,
})

const mapDispatch = (dispatch) => {
  const {
    AppUser: { login, facebookLogin, fetchMe, googleLogin },
    Language: { updateLocale },
  } = dispatch
  return {
    login,
    facebookLogin,
    googleLogin,
    updateLocale,
    fetchMe,
  }
}

export default connect(mapState, mapDispatch)(LogInPage)
